import React, { useState, useEffect, useRef } from 'react';
import styled from 'styled-components';
import { BiDownArrow } from 'react-icons/bi';

const Container = styled.div`
  position: relative;
  display: inline-block;
  text-align: center;
  width: 100%;
  font-size: 14px;
  border: 1.5px solid #d2d2d7;
  border-radius: 10px;
  transition: border-color 0.2s;
  &:hover {
    border-color: #86868b;
  }
`;

const Clickable = styled.div`
  width: 100%;
  padding: 5px 10px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  :hover {
    font-weight: 500;
  }
`;

const List = styled.div`
  border: 1px solid #d2d2d7;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  border-radius: 10px;
  background-color: white;
  position: absolute;
  width: 100%;
  z-index: 10;
  max-height: 200px;
  overflow-y: auto;
`;

const Level = styled.div`
  margin: 0;
  padding: 8px 10px;
  cursor: pointer;
  :hover {
    background: rgba(0, 122, 255, 0.06);
    font-weight: 500;
  }
`;

const Dropdown = ({ _selectChange, name, data, value }) => {
  const [open, setOpen] = useState(false);
  const [dropdown, setDropdown] = useState(value);
  const ref = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const _handleSelect = (val) => {
    setOpen(false);
    setDropdown(val);
  };

  return (
    <Container ref={ref}>
      <Clickable onClick={() => setOpen(!open)}>
        {dropdown}
        <BiDownArrow size="10" />
      </Clickable>
      {open && (
        <List>
          {data.map((val) => (
            <Level key={val} onClick={() => { _selectChange(name, val); _handleSelect(val); }}>
              {val}
            </Level>
          ))}
        </List>
      )}
    </Container>
  );
};

export default Dropdown;
